import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import pages from "../../constants/pages";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 3,
        backgroundColor: "#f9f9f9",
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "#f44336", mb: 2 }} />
      <Typography variant="h3" sx={{ mb: 1 }}>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
        The page you’re looking for doesn’t exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(pages.home.route)}
        sx={{ borderRadius: 2, px: 3 }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default NotFound;
